/*!
 * ============================================================================
 *  Boars Night Out - Accessibility Remediation (jQuery)
 *  Site   : https://boarsnightout.com  (Shopify, Dawn-family theme)
 *  Target : WCAG 2.2 Level AA
 *  Bugs   : 3, 4, 12, 31, 32, 34, 37, 43, 44, 48, 61, 62, 63, 66
 * ----------------------------------------------------------------------------
 *  Every fix is wrapped in its own function and marked with its Bug ID so the
 *  blocks can be lifted out individually into theme.liquid / a theme asset.
 *  All fixes are:
 *    - guarded  (they no-op when their component is not on the page)
 *    - idempotent (safe to run twice, safe alongside the theme's own JS)
 *    - non destructive to visual design except where a fix is explicitly
 *      visual (Bug 12, Bug 66) - both are switchable in CONFIG below.
 *
 *  Install: load AFTER jQuery and after the theme JS, e.g. in theme.liquid
 *      {{ 'bno-a11y-remediation.js' | asset_url | script_tag }}
 *  (If jQuery is not present on the page the file loads it itself.)
 * ============================================================================
 */
(function () {
  'use strict';

  var CONFIG = {
    jqueryFallbackSrc: 'https://code.jquery.com/jquery-3.7.1.min.js',

    /* BUG 12 - set false if the "Shop all" restyle is handled in the theme CSS */
    applyShopAllLinkStyle: true,
    shopAllTextPattern: /^(shop all|view all|shop now)$/i,

    /* BUG 66 - visible text substitutions for raw-URL links */
    linkTextMap: [
      { match: /shopify\.com\/legal\/cookies/i,  text: 'Shopify Cookies Policy' },
      { match: /globalprivacycontrol\.org/i,     text: 'Global Privacy Control website' }
    ]
  };

  /* ---- bootstrap: use the page's jQuery, or load one ---------------------- */
  if (window.jQuery) {
    init(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = CONFIG.jqueryFallbackSrc;
    s.onload = function () { init(window.jQuery); };
    document.head.appendChild(s);
  }

  function init($) {
    $(function () {
      injectHelperStyles($);
      buildLiveRegions($);

      fixSearchDialogSemantics($);   // BUG 3
      fixSearchToggleState($);       // BUG 4
      fixShopAllControl($);          // BUG 12
      fixFilterLandmarkNoise($);     // BUG 31
      fixDuplicateFilterName($);     // BUG 32
      // fixFilterRemovalAnnouncement($); // BUG 34
      // fixPriceSliderFocusOrder($);   // BUG 37
      // fixQuantityAnnouncement($);    // BUG 43
      // fixSharePopupEscape($);        // BUG 44
      // fixCartRemovalAnnouncement($); // BUG 48
      fixFormErrorFocus($);          // BUG 61
      fixSingleErrorList($);         // BUG 62
      fixFormSuccessAnnouncement($); // BUG 63
      // fixRawUrlLinkText($);          // BUG 66
      fixStatementDialogAnnouncement($); // BUG 73
    });
  }

  /* ==========================================================================
   *  SHARED HELPERS
   * ======================================================================== */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
                  'select:not([disabled]), textarea:not([disabled]), summary, ' +
                  '[tabindex]:not([tabindex="-1"])';

  function injectHelperStyles($) {
    if ($('#a11y-remediation-styles').length) { return; }
    var css = [
      '.a11y-visually-hidden{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;',
      'overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0}',
      /* BUG 12 - link affordance for controls that navigate */
      // '.a11y-link-appearance{background:none!important;border:0!important;padding:0!important;',
      'min-height:0!important;color:inherit!important;text-decoration:underline!important;',
      'text-underline-offset:.2em;font-weight:inherit!important}',
      '.a11y-link-appearance:hover{text-decoration-thickness:2px}'
    ].join('');
    $('<style id="a11y-remediation-styles"></style>').text(css).appendTo('head');
  }

  /* Two persistent live regions. They must exist in the DOM BEFORE text is
     written into them, otherwise screen readers will not announce the change. */
  function buildLiveRegions($) {
    if (!$('#a11y-live-polite').length) {
      $('<div id="a11y-live-polite" class="a11y-visually-hidden" role="status" ' +
        'aria-live="polite" aria-atomic="true"></div>').appendTo('body');
    }
    if (!$('#a11y-live-assertive').length) {
      $('<div id="a11y-live-assertive" class="a11y-visually-hidden" role="alert" ' +
        'aria-live="assertive" aria-atomic="true"></div>').appendTo('body');
    }
  }

  function announce($, message, assertive) {
    if (!message) { return; }
    var $region = $(assertive ? '#a11y-live-assertive' : '#a11y-live-polite');
    $region.text('');
    window.setTimeout(function () { $region.text(message); }, 120);
    window.setTimeout(function () { $region.text(''); }, 6000);
  }

  /* Hide everything outside $dialog from assistive tech (modal semantics). */
  function hideBackground($, $dialog) {
    var $node = $dialog;
    while ($node.length && !$node.is('body')) {
      $node.siblings().each(function () {
        var $sib = $(this);
        if ($sib.is('script, style, link, #a11y-live-polite, #a11y-live-assertive')) { return; }
        if ($sib.attr('data-a11y-bg') === 'true') { return; }
        $sib.attr('data-a11y-bg', 'true');
        $sib.attr('data-a11y-prev-hidden', $sib.attr('aria-hidden') || '');
        $sib.attr('aria-hidden', 'true');
        if ($sib.is('summary')) {
          /* keep the toggle clickable (it closes the dialog) but out of tab order */
          $sib.attr('data-a11y-prev-tabindex', $sib.attr('tabindex') || '');
          $sib.attr('tabindex', '-1');
        } else {
          $sib.prop('inert', true);
        }
      });
      $node = $node.parent();
    }
  }

  function restoreBackground($) {
    $('[data-a11y-bg="true"]').each(function () {
      var $el = $(this);
      var prev = $el.attr('data-a11y-prev-hidden');
      if (prev) { $el.attr('aria-hidden', prev); } else { $el.removeAttr('aria-hidden'); }
      if ($el.is('summary')) {
        var t = $el.attr('data-a11y-prev-tabindex');
        if (t) { $el.attr('tabindex', t); } else { $el.removeAttr('tabindex'); }
        $el.removeAttr('data-a11y-prev-tabindex');
      } else {
        $el.prop('inert', false);
      }
      $el.removeAttr('data-a11y-bg').removeAttr('data-a11y-prev-hidden');
    });
  }

  function trapFocus($, e, $dialog) {
    if (e.key !== 'Tab') { return; }
    var $items = $dialog.find(FOCUSABLE).filter(':visible');
    if (!$items.length) { return; }
    var first = $items.get(0), last = $items.get($items.length - 1);
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function textOf($el) { return String($el && $el.text ? $el.text() : '').replace(/\s+/g, ' ').trim(); }

  /* ==========================================================================
   *  BUG 3  |  1.3.1 Info and Relationships  |  Header - Search dialog   [v2]
   *  Issue : opening Search announces surrounding page content; focus is not
   *          moved into the dialog.
   *  Why it keeps happening in this theme:
   *    a) JAWS only honours aria-modal="true" once focus is INSIDE the dialog.
   *       Dawn leaves focus on the <summary>, which sits inside <details> but
   *       OUTSIDE the .search-modal, so the whole page stays readable.
   *    b) The <summary> itself is outside the dialog, so it must be hidden from
   *       AT while the dialog is open - otherwise the toggle and the header
   *       around it are still announced.
   *    c) The dialog contains <form role="search"> (a nested SEARCH LANDMARK)
   *       and a decorative .modal-overlay, both of which JAWS announces on top
   *       of the dialog itself.
   *  Fix   : dialog semantics + focus into the search field, background hidden
   *          (aria-hidden + inert, summary included), interior landmark/
   *          decorative noise suppressed while open, Tab trapped, Esc closes
   *          and returns focus - everything restored on close.
   * ======================================================================== */
  function fixSearchDialogSemantics($) {
    var $modal = $('details-modal.header__search, .header__search details-modal, ' +
                   '#Details-search-modal, details.header__search').first();
    var $details = $modal.is('details') ? $modal : $modal.find('details').first();
    if (!$details.length) {
      $details = $('summary.modal__toggle, .header__icon--search').closest('details').first();
    }
    if (!$details.length || $details.data('a11ySearchBound')) { return; }

    var $summary = $details.children('summary').first();
    var $dialog  = $details.find('.search-modal, .modal__content, [role="dialog"]').first();
    if (!$dialog.length) { return; }

    /* correct dialog semantics (added only when the theme has not done it) */
    if (!$dialog.attr('role')) { $dialog.attr('role', 'dialog'); }
    $dialog.attr('aria-modal', 'true');
    if (!$dialog.attr('aria-label') && !$dialog.attr('aria-labelledby')) {
      $dialog.attr('aria-label', textOf($summary) || 'Search');
    }

    function searchField() {
      return $dialog.find('input[type="search"], .search__input, input[name="q"]')
                    .filter(':visible').first();
    }

    /* --- (c) silence the noise INSIDE the dialog -------------------------
     * A dialog should announce as: name + role, then the search field. A
     * nested search landmark, a decorative overlay and the icon spans inside
     * the toggle all add announcements on top of that. Everything here is
     * stored and reversed on close, so nothing changes outside the open state.
     */
    function quietInterior() {
      $dialog.find('form[role="search"], [role="search"], [role="region"], nav[aria-label]')
        .each(function () {
          var $el = $(this);
          if ($el.attr('data-a11y-quiet')) { return; }
          $el.attr('data-a11y-quiet', 'true');
          if ($el.attr('role')) { $el.attr('data-a11y-prev-role', $el.attr('role')).removeAttr('role'); }
          /* a <form>/<nav> with an accessible name is a landmark on its own */
          if ($el.attr('aria-label')) {
            $el.attr('data-a11y-prev-aria-label', $el.attr('aria-label')).removeAttr('aria-label');
          }
        });

      $dialog.find('.modal-overlay').not('[aria-hidden]')
        .attr('data-a11y-quiet-overlay', 'true').attr('aria-hidden', 'true');
    }

    function restoreInterior() {
      $dialog.find('[data-a11y-quiet="true"]').each(function () {
        var $el = $(this);
        var r = $el.attr('data-a11y-prev-role');
        var l = $el.attr('data-a11y-prev-aria-label');
        if (r) { $el.attr('role', r); }
        if (l) { $el.attr('aria-label', l); }
        $el.removeAttr('data-a11y-quiet').removeAttr('data-a11y-prev-role')
           .removeAttr('data-a11y-prev-aria-label');
      });
      $dialog.find('[data-a11y-quiet-overlay="true"]')
        .removeAttr('aria-hidden').removeAttr('data-a11y-quiet-overlay');
    }

    function openState() {
      quietInterior();
      hideBackground($, $dialog);          /* includes the <summary> toggle */
      window.setTimeout(function () {
        var $input = searchField();
        if ($input.length) { $input.trigger('focus'); }
        else { $dialog.attr('tabindex', '-1').trigger('focus'); }
      }, 60);
    }

    function closeState() {
      restoreInterior();
      restoreBackground($);
    }

    $details.on('toggle.a11y', function () {
      if ($details.prop('open')) { openState(); } else { closeState(); }
    });

    /* the panel can already be open when this script runs (deferred asset,
       or the theme restoring state) - apply the open handling straight away */
    if ($details.prop('open')) { openState(); }

    $details.on('keydown.a11y', function (e) {
      if (!$details.prop('open')) { return; }
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        $details.prop('open', false);
        closeState();
        $summary.trigger('focus');
      }
      trapFocus($, e, $dialog);
    });

    /* close button must also restore AT visibility and focus */
    $dialog.on('click.a11y', '.modal__close-button, .search-modal__close-button', function () {
      $details.prop('open', false);
      closeState();
      $summary.trigger('focus');
    });

    /* clicking the overlay closes the modal in Dawn - restore AT state too */
    $dialog.on('click.a11y', '.modal-overlay', function () {
      $details.prop('open', false);
      closeState();
      $summary.trigger('focus');
    });

    $details.data('a11ySearchBound', true);
  }

  /* ==========================================================================
   *  BUG 4  |  4.1.2 Name, Role, Value  |  Header - Search button
   *  Issue : JAWS announces "Search button collapsed" and the state never
   *          updates to expanded.
   *  Fix   : expose the toggle as a button with aria-haspopup="dialog" and a
   *          correctly synchronised aria-expanded state.
   * ======================================================================== */
  function fixSearchToggleState($) {
    var $summary = $('summary.modal__toggle, .header__icon--search, summary[aria-haspopup]')
                     .filter(function () { return $(this).is('summary'); }).first();
    if (!$summary.length || $summary.data('a11yStateBound')) { return; }

    var $details = $summary.closest('details');
    if (!$details.length) { return; }

    /* role="button" stops AT mapping the <details> disclosure state, so the
       state we set below is the only one announced. */
    $summary.attr('role', 'button');
    $summary.attr('aria-haspopup', 'dialog');
    if (!$summary.attr('aria-label') && !textOf($summary)) { $summary.attr('aria-label', 'Search'); }

    function sync() { $summary.attr('aria-expanded', $details.prop('open') ? 'true' : 'false'); }
    sync();
    $details.on('toggle.a11yState', sync);

    $summary.data('a11yStateBound', true);
  }

  /* ==========================================================================
   *  BUG 12  |  1.3.1 Info and Relationships  |  Main - "Shop all"
   *  Issue : the control navigates (so it is correctly an <a>) but is styled
   *          as a button, so appearance and role disagree.
   *  Fix   : keep link semantics (it changes the URL) and give it a link
   *          appearance. Set CONFIG.applyShopAllLinkStyle = false if the
   *          restyle is being done in the theme stylesheet instead.
   *  Note  : the reverse fix (real <button>) is only correct if the control
   *          performs an in-page action - it does not here.
   * ======================================================================== */
  function fixShopAllControl($) {
    var $links = $('main a, #MainContent a').filter(function () {
      return CONFIG.shopAllTextPattern.test(textOf($(this)));
    });
    if (!$links.length) { return; }

    $links.each(function () {
      var $a = $(this);
      /* never let a navigating control claim role="button" */
      if (($a.attr('role') || '').toLowerCase() === 'button') { $a.removeAttr('role'); }
      if (CONFIG.applyShopAllLinkStyle) { $a.addClass('a11y-link-appearance'); }
    });
  }

  /* ==========================================================================
   *  BUG 31  |  1.3.1 Info and Relationships  |  Collections - filters
   *  Issue : expanding a filter exposes extra landmark regions, producing
   *          redundant landmark announcements.
   *  Fix   : neutralise landmark roles that sit INSIDE an expanded filter
   *          panel. Live regions (status / alert) are deliberately preserved.
   * ======================================================================== */
  function fixFilterLandmarkNoise($) {
    var $panels = $('details.js-filter, .facets__disclosure, .facets__disclosure-vertical, ' +
                    '.mobile-facets__details, facet-filters-form details');
    if (!$panels.length) { return; }

    $panels.each(function () {
      var $panel = $(this);

      /* elements inside the panel that create a landmark */
      $panel.find('aside, section[aria-label], section[aria-labelledby], nav, ' +
                  '[role="region"], [role="complementary"], [role="navigation"], ' +
                  '[role="search"], [role="form"], [role="main"]')
        .each(function () {
          var $el = $(this);
          if ($el.is('[role="status"], [role="alert"], [aria-live]')) { return; }
          if ($el.attr('data-a11y-landmark-cleared')) { return; }

          /* IMPORTANT: role="presentation" is IGNORED by the ARIA-in-HTML
             conflict-resolution rules while the element still carries a global
             ARIA attribute such as aria-label, so the accessible name has to be
             removed as well or the landmark stays in the accessibility tree. */
          if ($el.attr('aria-label')) {
            $el.attr('data-a11y-prev-label', $el.attr('aria-label')).removeAttr('aria-label');
          }
          if ($el.attr('aria-labelledby')) {
            $el.attr('data-a11y-prev-labelledby', $el.attr('aria-labelledby')).removeAttr('aria-labelledby');
          }
          $el.attr('data-a11y-landmark-cleared', 'true').attr('role', 'presentation');
        });

      /* a <form> is only a landmark when it has an accessible name - drop the
         name on nested forms rather than the form element itself */
      $panel.find('form[aria-label], form[aria-labelledby]').each(function () {
        $(this).removeAttr('aria-label').removeAttr('aria-labelledby');
      });
    });
  }

  /* ==========================================================================
   *  BUG 32  |  4.1.2 Name, Role, Value  |  Collections - Availability filter
   *  Issue : "Availability (1 selected) button expanded" then "Availability"
   *          again - the label is exposed twice.
   *  Fix   : one accessible name per control. Remove a duplicated aria-label
   *          on the summary and hide the repeated label text rendered inside
   *          the panel from assistive technology.
   * ======================================================================== */
  function fixDuplicateFilterName($) {
    var $summaries = $('details.js-filter > summary, .facets__disclosure > summary, ' +
                       '.facets__disclosure-vertical > summary, .mobile-facets__details > summary');
    if (!$summaries.length) { return; }

    $summaries.each(function () {
      var $summary = $(this);
      var visible  = textOf($summary);
      var $details = $summary.parent();

      /* 1. visible text + aria-label on the same control = two names */
      if (visible && $summary.attr('aria-label')) { $summary.removeAttr('aria-label'); }
      if (visible && $summary.attr('title')) { $summary.removeAttr('title'); }

      /* 2. decorative duplicates inside the summary (e.g. sr-only copy) */
      $summary.find('.visually-hidden, .sr-only, .a11y-visually-hidden').each(function () {
        var t = textOf($(this));
        if (t && visible.indexOf(t) !== -1 && visible !== t) { $(this).attr('aria-hidden', 'true'); }
      });

      /* 3. the same label repeated as static text at the top of the panel */
      var base = visible.replace(/\s*\(.*?\)\s*/g, '').trim().toLowerCase();
      if (!base) { return; }
      $details.children().not('summary').each(function () {
        $(this).find('span, p, h2, h3, h4, legend, label').addBack()
          .filter(function () {
            var $n = $(this);
            if ($n.is('label')) { return false; }              /* real field labels stay */
            if ($n.find(FOCUSABLE).length) { return false; }   /* never hide a control */
            if ($n.attr('aria-hidden') === 'true') { return false; }
            return textOf($n).toLowerCase() === base;
          })
          .attr('aria-hidden', 'true');
      });

      /* 4. panel must not re-announce the summary's name */
      $details.children('[aria-labelledby], [aria-label]').not('summary').each(function () {
        var $p = $(this);
        var nm = ($p.attr('aria-label') || '').trim().toLowerCase();
        if (nm && nm === base) { $p.removeAttr('aria-label'); }
      });
    });
  }

  /* ==========================================================================
   *  BUG 34  |  4.1.3 Status Messages  |  Collections - filters
   *  Issue : removing a filter produces no status message.
   *  Fix   : announce every filter removal politely, and follow it with the
   *          updated result count once the section has re-rendered.
   * ======================================================================== */
  // function fixFilterRemovalAnnouncement($) {
  //   var $facets = $('#FacetFiltersForm, facet-filters-form, #main-collection-filters, .facets-container');
  //   if (!$facets.length) { return; }

  //   function resultCount() {
  //     var t = textOf($('#ProductCountDesktop, #ProductCount, .product-count__text').first());
  //     return t ? '. ' + t : '';
  //   }

  //   /* chip / "Remove all" links in the active-facets bar */
  //   $(document).on('click.a11y34', 'facet-remove a, .active-facets__button, a.active-facets__button--light', function () {
  //     var label = textOf($(this)).replace(/\s*(remove|clear)\s*/i, '').trim();
  //     var all   = /clear all|remove all/i.test(textOf($(this)));
  //     announce($, all ? 'All filters removed' : (label ? label + ' filter removed' : 'Filter removed'));
  //   });

  //   /* unchecking a filter checkbox is also a removal */
  //   $(document).on('change.a11y34', '.facets input[type="checkbox"], facet-filters-form input[type="checkbox"], .mobile-facets input[type="checkbox"]', function () {
  //     if (this.checked) { return; }
  //     var name = textOf($(this).closest('label')) || $(this).attr('value') || 'Filter';
  //     announce($, name + ' filter removed');
  //   });

  //   /* price range cleared */
  //   $(document).on('change.a11y34', 'price-range input, .facets__price input', function () {
  //     if ($(this).val() === '') { announce($, 'Price filter removed'); }
  //   });

  //   /* confirm with the new result count after the section re-renders */
  //   var target = $('#ProductGridContainer, #product-grid, .collection').get(0);
  //   if (target && window.MutationObserver) {
  //     var timer = null;
  //     new window.MutationObserver(function () {
  //       window.clearTimeout(timer);
  //       timer = window.setTimeout(function () {
  //         var c = resultCount();
  //         if (c) { announce($, c.replace(/^\.\s*/, '')); }
  //       }, 700);
  //     }).observe(target, { childList: true, subtree: true });
  //   }
  // }

  /* ==========================================================================
   *  BUG 37  |  2.4.3 Focus Order  |  Collections - price / range slider
   *  Issue : Tab moves through the slider controls in an order that does not
   *          match the visual order.
   *  Fix   : re-order the DOM so it matches the visual (left-to-right,
   *          top-to-bottom) order. Nodes are MOVED, not cloned, so the theme's
   *          own event handlers and element references survive.
   * ======================================================================== */
  // function fixPriceSliderFocusOrder($) {
  //   var $containers = $('price-range, .facets__price, .mobile-facets__price, ' +
  //                       '.price-range, [data-price-range], .slider-component');
  //   if (!$containers.length) { return; }

  //   $containers.each(function () {
  //     var $c = $(this);
  //     if ($c.data('a11yOrdered')) { return; }

  //     var $kids = $c.children().filter(function () {
  //       var $k = $(this);
  //       return ($k.is(FOCUSABLE) || $k.find(FOCUSABLE).length) && $k.is(':visible');
  //     });
  //     if ($kids.length < 2) { return; }

  //     var ordered = $kids.get().slice().sort(function (a, b) {
  //       var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
  //       if (Math.abs(ra.top - rb.top) > 8) { return ra.top - rb.top; }
  //       return ra.left - rb.left;
  //     });

  //     var changed = ordered.some(function (el, i) { return el !== $kids.get(i); });
  //     if (changed) { ordered.forEach(function (el) { $c.append(el); }); }

  //     /* any custom slider handle must be reachable and self-describing */
  //     $c.find('[role="slider"]').each(function () {
  //       var $h = $(this);
  //       if (!$h.attr('tabindex')) { $h.attr('tabindex', '0'); }
  //       if (!$h.attr('aria-valuenow') && $h.attr('data-value')) {
  //         $h.attr('aria-valuenow', $h.attr('data-value'));
  //       }
  //     });

  //     $c.data('a11yOrdered', true);
  //   });
  // }

  /* ==========================================================================
   *  BUG 43  |  4.1.3 Status Messages  |  Product - quantity selector
   *  Issue : +/- change the quantity visually but nothing is announced.
   *  Fix   : announce the new quantity politely after each change.
   * ======================================================================== */
  // function fixQuantityAnnouncement($) {
  //   var $inputs = $('quantity-input input.quantity__input, .quantity input[type="number"], ' +
  //                   'input[name="quantity"], input[name="updates[]"]');
  //   if (!$inputs.length) { return; }

  //   $inputs.each(function () {
  //     var $input = $(this);
  //     if ($input.data('a11yQtyBound')) { return; }
  //     $input.data('a11yQtyBound', true).data('a11yQtyPrev', parseInt($input.val(), 10) || 0);

  //     var $wrap = $input.closest('quantity-input, .quantity');
  //     var timer = null;

  //     function report() {
  //       window.clearTimeout(timer);
  //       timer = window.setTimeout(function () {
  //         var now  = parseInt($input.val(), 10);
  //         var prev = $input.data('a11yQtyPrev');
  //         if (isNaN(now) || now === prev) { return; }
  //         $input.data('a11yQtyPrev', now);
  //         announce($, (now > prev ? 'Quantity increased to ' : 'Quantity decreased to ') + now);
  //       }, 250);
  //     }

  //     $wrap.on('click.a11y43', 'button[name="plus"], button[name="minus"], .quantity__button', report);
  //     $input.on('change.a11y43 input.a11y43', report);
  //   });
  // }

  /* ==========================================================================
   *  BUG 44  |  2.1.1 Keyboard  |  Product - Share link popup
   *  Issue : the Share popup cannot be dismissed with Esc.
   *  Fix   : Esc closes the popup and returns focus to the Share control.
   *          Clicking outside also closes it (focus is left where the user
   *          clicked, as expected for a click dismissal).
   * ======================================================================== */
  // function fixSharePopupEscape($) {
  //   var $shares = $('share-button, .share-button').filter(function () {
  //     return $(this).find('details').length || $(this).is('details');
  //   });
  //   if (!$shares.length) { return; }

  //   $shares.each(function () {
  //     var $host    = $(this);
  //     var $details = $host.is('details') ? $host : $host.find('details').first();
  //     if (!$details.length || $details.data('a11yEscBound')) { return; }
  //     var $summary = $details.children('summary').first();

  //     function close(returnFocus) {
  //       if (!$details.prop('open')) { return; }
  //       $details.prop('open', false);
  //       $summary.attr('aria-expanded', 'false');
  //       if (returnFocus) { $summary.trigger('focus'); }
  //     }

  //     /* keydown on the component (covers focus inside the popup) ... */
  //     $details.on('keydown.a11y44', function (e) {
  //       if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); close(true); }
  //     });
  //     /* ... and at document level, for when focus has drifted to <body> */
  //     $(document).on('keydown.a11y44', function (e) {
  //       if ((e.key === 'Escape' || e.key === 'Esc') && $details.prop('open')) { close(true); }
  //     });

  //     $(document).on('click.a11y44', function (e) {
  //       if ($details.prop('open') && !$.contains($details.get(0), e.target)) { close(false); }
  //     });

  //     $details.on('toggle.a11y44', function () {
  //       $summary.attr('aria-expanded', $details.prop('open') ? 'true' : 'false');
  //     });
  //     $summary.attr('aria-expanded', $details.prop('open') ? 'true' : 'false');

  //     $details.data('a11yEscBound', true);
  //   });
  // }

  /* ==========================================================================
   *  BUG 48  |  4.1.3 Status Messages  |  Cart - remove item
   *  Issue : removing a line item is not announced.
   *  Fix   : capture the product name on activation, then announce
   *          "<product> removed from your cart" once the cart re-renders.
   * ======================================================================== */
  // function fixCartRemovalAnnouncement($) {
  //   var $cart = $('cart-items, #main-cart-items, .cart__items, cart-drawer-items');
  //   if (!$cart.length) { return; }

  //   function nameFor($ctl) {
  //     var $row = $ctl.closest('[id^="CartItem"], .cart-item, tr');
  //     var n = textOf($row.find('.cart-item__name, .cart-item__details a, a.cart-item__name').first());
  //     if (!n) {
  //       n = ($ctl.attr('aria-label') || '').replace(/^remove\s*/i, '').trim();
  //     }
  //     return n || 'Item';
  //   }

  //   var pending = null;

  //   $(document).on('click.a11y48', 'cart-remove-button a, cart-remove-button button, ' +
  //     '.cart-remove-button a, a[href*="/cart/change"], .cart-item__remove', function () {
  //     pending = nameFor($(this));
  //   });

  //   /* setting the quantity to 0 removes the line item too */
  //   $(document).on('change.a11y48', 'cart-items input[name="updates[]"], .cart__items input[name="updates[]"]', function () {
  //     if (parseInt($(this).val(), 10) === 0) { pending = nameFor($(this)); }
  //   });

  //   if (window.MutationObserver) {
  //     var timer = null;
  //     new window.MutationObserver(function () {
  //       if (!pending) { return; }
  //       window.clearTimeout(timer);
  //       timer = window.setTimeout(function () {
  //         var count = $('[id^="CartItem"], .cart-item').filter(':visible').length;
  //         var tail  = count ? ' ' + count + (count === 1 ? ' item' : ' items') + ' remaining in your cart.' : ' Your cart is empty.';
  //         announce($, pending + ' removed from your cart.' + tail);
  //         pending = null;
  //       }, 100);
  //     }).observe($cart.get(0), { childList: true, subtree: true });
  //   }
  // }

  /* ==========================================================================
   *  BUG 61  |  2.4.3 Focus Order  |  Contact - validation focus
   *  Issue : after a failed submit, focus lands at the top of the page instead
   *          of the field in error.
   *  Fix   : mark the invalid field (aria-invalid + aria-describedby pointing
   *          at the error text) and move focus to it, on both the server
   *          round-trip and client-side validation.
   * ======================================================================== */
  function fixFormErrorFocus($) {
    var $form = $('#ContactForm, form[action*="/contact"]').first();
    if (!$form.length) { return; }

    function markAndFocus($field, message) {
      if (!$field.length) { return; }
      $field.attr('aria-invalid', 'true');
      var errId = $field.attr('id') ? $field.attr('id') + '-error' : 'a11y-field-error';
      if (message) {
        var $err = $('#' + errId);
        if (!$err.length) {
          $err = $('<span id="' + errId + '" class="a11y-visually-hidden"></span>').insertAfter($field);
        }
        $err.text(message);
      }
      var described = ($field.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (described.indexOf(errId) === -1 && $('#' + errId).length) {
        described.push(errId);
        $field.attr('aria-describedby', described.join(' '));
      }
      window.setTimeout(function () { $field.trigger('focus'); }, 150);
    }

    /* --- after a server-side round trip ---------------------------------- */
    var $summary = $('.form-status[role="alert"], .form__message .form-status').first();
    var isError  = $summary.length && !$summary.hasClass('form-status-list') &&
                   /invalid|error|required|wrong/i.test(textOf($summary) + ' ' + textOf($summary.parent()));

    if ($summary.length && $('.form-status-list a[href^="#"]').length) { isError = true; }

    if (isError) {
      /* focus belongs on the field, not the summary heading */
      $summary.removeAttr('autofocus');

      /* role="alert" is not an allowed role for <h2> (ARIA in HTML) and axe
         flags it. The error is announced by the focus move + aria-describedby
         below, so the invalid role is simply removed. */
      if (($summary.attr('role') || '').toLowerCase() === 'alert') { $summary.removeAttr('role'); }
      var href    = $('.form-status-list a[href^="#"]').first().attr('href');
      var $field  = href ? $(href) : $form.find('[aria-invalid="true"]').first();
      if (!$field || !$field.length) { $field = $form.find('#ContactForm-email'); }
      markAndFocus($field, textOf($('.form-status-list li').first()) || textOf($summary));
    }

    /* --- client-side validation ------------------------------------------ */
    $form.on('submit.a11y61', function (e) {
      var $bad = $form.find(':input').filter(function () {
        return this.willValidate && !this.checkValidity();
      }).first();
      if ($bad.length) {
        e.preventDefault();
        markAndFocus($bad, $bad.get(0).validationMessage);
        announce($, $bad.get(0).validationMessage, true);
      }
    });

    /* clear the invalid state once the user corrects the field */
    $form.on('input.a11y61 change.a11y61', ':input', function () {
      if (this.willValidate && this.checkValidity()) { $(this).attr('aria-invalid', 'false'); }
    });
  }

  /* ==========================================================================
   *  BUG 62  |  1.3.1 Info and Relationships  |  Contact - error summary
   *  Issue : a single validation error is wrapped in a one-item list.
   *  Fix   : render a single error as a paragraph; keep list markup only when
   *          there are two or more errors.
   * ======================================================================== */
  function fixSingleErrorList($) {
    $('ul.form-status-list, .form__message ul, .form-status + ul').each(function () {
      var $ul = $(this);
      var $li = $ul.children('li');
      if ($li.length !== 1) { return; }               /* 2+ errors: a list is correct */
      var $p = $('<p></p>')
        .attr('class', $ul.attr('class') || '')
        .attr('id', $ul.attr('id') || null)
        .html($li.first().html());
      $ul.replaceWith($p);
    });

    /* Non-destructive alternative, if the markup must not be rewritten:
     *   $('ul.form-status-list').filter(function(){return $(this).children('li').length===1;})
     *     .attr('role','presentation').children('li').attr('role','presentation');
     */
  }

  /* ==========================================================================
   *  BUG 63  |  4.1.3 Status Messages  |  Contact - success message
   *  Issue : the success message is rendered on page load, so a live region
   *          on that element is never announced.
   *  Fix   : mirror the message into a live region that already exists in the
   *          DOM, shortly after load, without moving focus.
   * ======================================================================== */
  function fixFormSuccessAnnouncement($) {
    var $success = $('.form-status.form-status-list, .form__message.form-status, ' +
                     '.form-status').filter(function () {
      return /thanks for contacting|success|we.ll get back/i.test(textOf($(this)));
    }).first();
    if (!$success.length) { return; }

    /* NOTE: do not add role="status" to the message element itself - the theme
       renders it as an <h2>, and status/alert are not allowed roles for a
       heading (ARIA in HTML). The dedicated live region below does the work. */
    if ($success.is('h1, h2, h3, h4, h5, h6') &&
        /^(status|alert)$/i.test($success.attr('role') || '')) { $success.removeAttr('role'); }

    /* If the theme already sends focus to the message (autofocus / tabindex=-1)
       the screen reader will read it on focus, so mirroring it into a live
       region as well would announce it twice. Only mirror when it does not. */
    var node = $success.get(0);
    window.setTimeout(function () {
      var focused = document.activeElement === node ||
                    (node.contains && node.contains(document.activeElement));
      if (focused) { return; }               /* already spoken on focus */
      announce($, textOf($success));
    }, 500);
  }

  /* ==========================================================================
   *  BUG 66  |  2.4.4 Link Purpose (In Context)  |  Privacy Policy
   *  Issue : raw URLs are used as visible link text.
   *  Fix   : replace the visible text with a descriptive label; href unchanged.
   * ======================================================================== */
  function fixRawUrlLinkText($) {
    var $links = $('a[href]').filter(function () {
      return /^\s*(https?:\/\/|www\.)\S+\s*$/i.test(textOf($(this)));
    });
    if (!$links.length) { return; }

    $links.each(function () {
      var $a   = $(this);
      var href = $a.attr('href') || '';
      var label = null;

      for (var i = 0; i < CONFIG.linkTextMap.length; i++) {
        if (CONFIG.linkTextMap[i].match.test(href) || CONFIG.linkTextMap[i].match.test(textOf($a))) {
          label = CONFIG.linkTextMap[i].text;
          break;
        }
      }

      if (!label) {
        /* generic fallback: last meaningful path segment + host, title-cased */
        try {
          var u    = new URL(href, window.location.origin);
          var seg  = u.pathname.split('/').filter(Boolean).pop();
          var host = u.hostname.replace(/^www\./, '');
          var pretty = seg ? seg.replace(/[-_]+/g, ' ').replace(/\.\w+$/, '') : '';
          label = pretty
            ? pretty.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) + ' (' + host + ')'
            : host + ' website';
        } catch (err) { return; }
      }

      $a.text(label);
      if ($a.attr('target') === '_blank' && !/new (tab|window)/i.test(label)) {
        $a.append($('<span class="a11y-visually-hidden"> (opens in a new tab)</span>'));
      }
    });
  }


  /* ==========================================================================
   *  BUG 73  |  4.1.3 Status Messages  |  Accessibility Statement panel
   *  Widget : "Accessibly" Shopify app  (#accessiblyWidgetLandmark)
   *  Issue : the widget re-uses ONE dialog container (#accessiblyAppDialog)
   *          and swaps its inner views (.accessibly-app-tab). Opening
   *          "Accessibility statement" only swaps the active view, so nothing
   *          is announced - no dialog, no title, no available actions - and
   *          focus stays where it was.
   *  Fix   : watch the widget for view changes; on every change while the
   *          dialog is open, confirm the dialog semantics + accessible name,
   *          move focus to the Back button of the new view, and announce
   *          "<title> dialog. Back and Close ... are available." politely.
   *          The first view after opening is NOT announced - the widget's own
   *          dialog announcement already covers it.
   * ======================================================================== */
  function fixStatementDialogAnnouncement($) {
    var DIALOG   = '#accessiblyAppDialog';
    var LANDMARK = '#accessiblyWidgetLandmark';
    var VIEW     = '.accessibly-app-tab';
    var ACTIVE   = 'accessibly-app-tab-active';

    var FALLBACK_NAMES = {
      'accessibly-app-statement':      'Accessibility statement',
      'accessibly-app-features':       'Accessibility options',
      'accessibly-app-settings':       'Settings',
      'accessibly-app-page-structure': 'Page structure'
    };

    var lastView = null, wasOpen = false, tries = 0;

    /* the widget is injected asynchronously - wait for it, then bind once */
    var poll = window.setInterval(function () {
      tries++;
      if ($(LANDMARK).length || $(DIALOG).length) { window.clearInterval(poll); bind(); }
      else if (tries > 60) { window.clearInterval(poll); }   /* ~30s, then give up */
    }, 500);

    function bind() {
      var host = ($(LANDMARK).get(0) || $(DIALOG).parent().get(0) || document.body);
      sync();                                   /* baseline, never announces */
      if (!window.MutationObserver) { return; }
      var pending = null;
      new window.MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(sync, 120); /* debounce the app's re-renders */
      }).observe(host, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['class', 'hidden', 'style', 'aria-hidden']
      });
    }

    function isOpen($d) {
      return !!$d.length && !$d.prop('hidden') && !$d.attr('hidden') &&
             $d.attr('aria-hidden') !== 'true' && $d.is(':visible');
    }

    function viewKey($view) {
      var cls = ($view.attr('class') || '').split(/\s+/);
      for (var i = 0; i < cls.length; i++) {
        if (cls[i] && cls[i] !== ACTIVE && cls[i].indexOf('accessibly-app-') === 0 &&
            cls[i] !== 'accessibly-app-tab' && cls[i] !== 'accessibly-app-ignore') { return cls[i]; }
      }
      return null;
    }

    function viewTitle($d, key) {
      var t = textOf($d.find('#accessiblyAppDialogTitle, .accessibly-app-navigation-title').first());
      return t || FALLBACK_NAMES[key] || 'Dialog';
    }

    function backButton($d) {
      return $d.find('button:visible').filter(function () {
        var $b = $(this);
        return /^back$/i.test(textOf($b)) ||
               /^back$/i.test($b.attr('aria-label') || '') ||
               $b.find('.accessibly-app-icon-arrow-back').length > 0;
      }).first();
    }

    /* "Back and Close Accessibility widget buttons are available." */
    function actionsSentence($d) {
      var names = [];
      $d.find('button:visible').each(function () {
        var $b = $(this);
        var n = ($b.attr('aria-label') || textOf($b) || '').replace(/\s+/g, ' ').trim();
        if (!n || n.length > 40) { return; }
        if (!/^(back|close)/i.test(n)) { return; }          /* dialog chrome only */
        if (names.indexOf(n) === -1) { names.push(n); }
      });
      if (!names.length) { return ''; }
      return ' ' + names.join(' and ') + (names.length > 1 ? ' buttons are' : ' button is') + ' available.';
    }

    function ensureSemantics($d) {
      if (!$d.attr('role')) { $d.attr('role', 'dialog'); }   /* app ships alertdialog - left as-is */
      if ($d.attr('aria-modal') !== 'true') { $d.attr('aria-modal', 'true'); }
      if ($d.attr('tabindex') === undefined) { $d.attr('tabindex', '-1'); }

      var $title = $d.find('#accessiblyAppDialogTitle, .accessibly-app-navigation-title').first();
      if ($title.length) {
        if (!$title.attr('id')) { $title.attr('id', 'a11y-statement-dialog-title'); }
        if (!$d.attr('aria-labelledby') && !$d.attr('aria-label')) {
          $d.attr('aria-labelledby', $title.attr('id'));
        }
        /* role="heading" without a level defaults to 2 - make it explicit */
        if (($title.attr('role') || '') === 'heading' && !$title.attr('aria-level')) {
          $title.attr('aria-level', '2');
        }
      }
    }

    function sync() {
      var $d = $(DIALOG);
      if (!$d.length) { return; }

      if (!isOpen($d)) { wasOpen = false; lastView = null; return; }

      var $view = $d.find(VIEW + '.' + ACTIVE).first();
      var key   = $view.length ? viewKey($view) : 'default';

      if (!wasOpen) {                    /* dialog just opened - baseline only */
        wasOpen = true;
        lastView = key;
        ensureSemantics($d);
        return;
      }
      if (key === lastView) { return; }  /* no view change */
      lastView = key;

      ensureSemantics($d);

      var title = viewTitle($d, key);
      announce($, title + ' dialog.' + actionsSentence($d));

      /* focus the Back control of the new view so the dialog is entered */
      window.setTimeout(function () {
        var $back = backButton($d);
        if ($back.length) { $back.trigger('focus'); }
        else { $d.attr('tabindex', '-1').trigger('focus'); }
      }, 80);
    }
  }

})();